/**
 * Test-mode helpers for the AF feedback round.
 *
 * Visit any MOT page with ?test=1 — we stash the flag in sessionStorage so
 * it persists for the tab. Every subsequent fetch/axios call attaches
 * X-Mot-Test: 1, which lets the backend bypass the phase gate (only if
 * mot-setting.testMode is also true). Records submitted this way are
 * tagged isTest=true so `node scripts/cleanup-mot-test-records.js`
 * can wipe them in one go before launch.
 *
 * Browser-only: every function returns false / {} on SSR.
 */

const STORAGE_KEY = 'motTestMode';

const isBrowser = () => typeof window !== 'undefined';

// Read ?test=1 from the URL on every call and cache it. Once set, it
// survives navigation within the tab via sessionStorage.
export function isTestMode() {
  if (!isBrowser()) return false;

  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('test') === '1') {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
      return true;
    }
    return window.sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

// Spread into fetch/axios config: { headers: { ...getTestHeaders() } }
export function getTestHeaders() {
  return isTestMode() ? { 'X-Mot-Test': '1' } : {};
}

// For UI affordances (badge, banner) that need to know.
export function clearTestMode() {
  if (!isBrowser()) return;
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // noop
  }
}
